"use strict";
/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.truncateText = exports.str2Currency = exports.str2NumericStr = exports.dateStrReplaceCN = exports.string2Segment = exports.stringHash2Number = exports.parseAllUrl = exports.hiddenMobile = exports.isPhoneNumber = exports.isEmail = exports.isEmailUrl = exports.isUrl = exports.hasUrlProtocol = exports.isVCode = exports.LINK_REG = exports.escapeHtml = exports.isValidName = exports.MAX_NAME_STRING_LENGTH = exports.generateRandomString = void 0;
const field_types_1 = require("../types/field_types");
const phone_1 = require("phone");
const string_prototype_matchall_1 = require("string.prototype.matchall");
(0, string_prototype_matchall_1.shim)();
const chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz';
function generateRandomString(length = 20) {
    let randomString = '';
    const size = chars.length;
    for (let i = 0; i < length; i++) {
        const randomNumber = Math.floor(Math.random() * size);
        randomString += chars[randomNumber];
    }
    return randomString;
}
exports.generateRandomString = generateRandomString;
exports.MAX_NAME_STRING_LENGTH = 100;
function isValidName(name) {
    if (!name || (typeof name !== 'string')) {
        return false;
    }
    if (name.length > exports.MAX_NAME_STRING_LENGTH || name.length === 0) {
        return false;
    }
    if (name.trim().length === 0) {
        return false;
    }
    // if (/[*:/?[\]\\]/.test(name)) {
    //   return false;
    // }
    return true;
}
exports.isValidName = isValidName;
/* eslint-disable @typescript-eslint/naming-convention */
var EscapeMap;
(function (EscapeMap) {
    EscapeMap["&"] = "&amp;";
    EscapeMap["<"] = "&lt;";
    EscapeMap[">"] = "&gt;";
    EscapeMap["\""] = "&quot;";
    EscapeMap["'"] = "&#x27;";
    EscapeMap["`"] = "&#x60;";
})(EscapeMap || (EscapeMap = {}));
/* eslint-enable @typescript-eslint/naming-convention */
const escapeHtml = (str) => {
    const replaceReg = new RegExp('(?:&|<|>|"|\'|`)', 'g');
    return replaceReg.test(str) ? str.replace(replaceReg, m => EscapeMap[m]) : str;
};
exports.escapeHtml = escapeHtml;
const URL_PROTOCOL_REG = /^(https?|ftp):\/\/|mailto:/i;
const PROTOCOL = 'https?|s?ftp|ftps|nfs|ssh';
const LINK_SUFFIX = '\\b([/?#][-a-zA-Z0-9@:%_+.~#?&/=;$,!\\*\\[\\]{}^|<>]*)?';
const URL_HOST_BODY = '([\\-a-zA-Z0-9:%_+~#@]{1,256}\\.){1,50}';
const ANY_TOP_DOMAIN = '[a-z\\-]{2,15}';
/* eslint-disable */
const TOP_DOMAIN = 'com|org|net|int|edu|gov|mil|ac|ad|ae|af|ag|ai|al|am|an|ao|aq|ar|as|at|au|aw|ax|az|ba|bb|bd|be|bf|bg|bh|bi|bj|bm|bn|bo|br|bs|bt|bv|bw|by|bz|ca|cc|cf|cg|ch|ci|ck|cl|cm|cn|co|cr|cu|cv|cw|cx|cy|cz|de|dj|dk|dm|do|dz|ec|ee|eg|eh|er|es|et|eu|fi|fj|fk|fm|fo|fr|ga|gb|gd|ge|gf|gh|gi|gl|gm|gn|gp|gr|gs|gt|gu|gw|gy|hk|hm|hn|hr|ht|hu|id|ie|il|im|in|io|iq|ir|is|it|jm|jo|jp|ke|kg|kh|ki|km|kn|kp|kr|kw|ky|kz|la|lb|lc|li|lk|lr|ls|lt|lu|lv|ly|ma|mc|md|me|mf|mg|mh|mk|ml|mm|mn|mo|mp|mq|mr|ms|mt|mu|mv|mw|mx|my|mz|na|nc|ne|nf|ng|ni|nl|no|np|nr|nu|nz|om|pa|pe|pf|pg|ph|pk|pl|pm|pn|pr|ps|pt|pw|py|qa|re|ro|rs|ru|rw|sa|sb|sc|sd|se|sg|sh|si|sj|sk|sl|sm|sn|so|sr|ss|st|su|sv|sx|sy|sz|tc|td|tf|tg|th|tj|tk|tl|tm|tn|to|tp|tr|tt|tv|tw|tz|ua|ug|uk|um|us|uy|uz|va|vc|ve|vg|vi|vn|vu|wf|ws|ye|yt|za|zm|zw|site|top|wtf|xxx|xyz|cloud|engineering|help|one';
const TOP_10_DOMAIN = 'com|cn|tk|de|net|org|uk|info|nl|ru';
// Since the top-level domain name is incomplete, it is changed to a url with a protocol header, ignoring the above top-level domain name and matching directly
const URL_REG = new RegExp(`(((${PROTOCOL}):\\/\\/${URL_HOST_BODY}${ANY_TOP_DOMAIN})|(${URL_HOST_BODY}(${TOP_10_DOMAIN})))(:[0-9]{2,5})?${LINK_SUFFIX}`, 'gi');
// Mailto's greedy matching will be very slow when encountering extremely long strings (English without spaces), and the length needs to be limited.
const EMAIL_URL_BODY = '[\\w.!#$%&\'*+-/=?^_\\`{|}~]{1,2000}@[A-Za-z0-9_.-]+\\.';
const LENGTH_LIMITED_EMAIL_REG = new RegExp(`^(?!data:)((mailto:${EMAIL_URL_BODY}${ANY_TOP_DOMAIN})|(${EMAIL_URL_BODY}(${TOP_DOMAIN})))\\b`, 'gi');
const LOCALHOST_REG = /localhost:[0-9]{2,5}/;
const IP_ADDRESS_REG = /(([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\.){3}(2[0-4][0-9]|25[0-5]|1[0-9]{2}|[1-9][0-9]|[0-9])(:[0-9]{2,5})?/;
const IP_REG = new RegExp(`((https?|http|ftp)://)?((${LOCALHOST_REG.source})|(${IP_ADDRESS_REG.source}))(/[-a-zA-Z0-9@:%_+.~#?&//=]*)?`, 'gi');
exports.LINK_REG = new RegExp(`(${IP_REG.source})|(${URL_REG.source})|(${LENGTH_LIMITED_EMAIL_REG.source})`, 'gi');
const EMAIL = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
const EMAIL_REG = /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/gi;
const VCODE_REG = /[\da-z]{8}/i;
function isVCode(code) {
    return new RegExp(VCODE_REG).test(code);
}
exports.isVCode = isVCode;
function hasUrlProtocol(url) {
    return new RegExp(URL_PROTOCOL_REG).test(url);
}
exports.hasUrlProtocol = hasUrlProtocol;
function isUrl(url) {
    return new RegExp(exports.LINK_REG).test(url);
}
exports.isUrl = isUrl;
function isEmailUrl(url) {
    return new RegExp(`^${LENGTH_LIMITED_EMAIL_REG.source}$`, 'i').test(url);
}
exports.isEmailUrl = isEmailUrl;
function isEmail(email) {
    return new RegExp(EMAIL).test(email);
}
exports.isEmail = isEmail;
function isPhoneNumber(phoneNumber, areaCode) {
    var _a;
    return (_a = (0, phone_1.phone)(areaCode + ' ' + phoneNumber)) === null || _a === void 0 ? void 0 : _a.isValid;
}
exports.isPhoneNumber = isPhoneNumber;
// Hide the middle 4 digits of the phone number
function hiddenMobile(mobileNumber) {
    return mobileNumber.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2');
}
exports.hiddenMobile = hiddenMobile;
function parseAllUrl(value) {
    const valueArray = [];
    let lastEndIndex = 0;
    const regExp = new RegExp(exports.LINK_REG);
    let execResult = regExp.exec(value);
    if (execResult == null) {
        return [{
                type: field_types_1.SegmentType.Text,
                text: value,
            }];
    }
    while (execResult) {
        const startIndex = execResult.index;
        const regExpMatch = execResult[0];
        if (startIndex !== lastEndIndex) {
            valueArray.push({
                type: field_types_1.SegmentType.Text,
                text: value.substring(lastEndIndex, startIndex),
            });
        }
        if (hasUrlProtocol(regExpMatch)) {
            valueArray.push({ type: field_types_1.SegmentType.Url, link: regExpMatch, text: regExpMatch });
        }
        else if (isUrl(regExpMatch)) {
            valueArray.push({ type: field_types_1.SegmentType.Url, link: `http://${regExpMatch}`, text: regExpMatch });
        }
        else if (isEmailUrl(regExpMatch)) {
            valueArray.push({ type: field_types_1.SegmentType.Url, link: `mailto:${regExpMatch}`, text: regExpMatch });
        }
        lastEndIndex = regExp.lastIndex;
        execResult = regExp.exec(value);
    }
    if (lastEndIndex < value.length) {
        valueArray.push({
            type: field_types_1.SegmentType.Text,
            text: value.substring(lastEndIndex),
        });
    }
    return valueArray;
}
exports.parseAllUrl = parseAllUrl;
const stringHash2Number = (str, range) => {
    /**
     * String str is mapped to a value in the specified range [0,range)
     */
    const sumOfStringCharCode = Array.from(str).map(c => c.charCodeAt(0)).reduce((a, b) => a + b);
    return Math.abs(sumOfStringCharCode % range);
};
exports.stringHash2Number = stringHash2Number;
/**
 * String is cut into segment with type by regex matching
 * @export
 * @param {string} str
 * @returns {ISegment[]}
 */
function string2Segment(str) {
    const segmentList = [];
    const urlTmp = {};
    // match URL
    const urlMatch = [...str.matchAll(exports.LINK_REG)];
    const emailMatch = [...str.matchAll(EMAIL_REG)];
    // If there is no URL/Email match, return directly to reduce unnecessary calculations
    if (!urlMatch.length && !emailMatch.length) {
        segmentList.push({
            type: field_types_1.SegmentType.Text,
            text: str,
        });
        return segmentList;
    }
    urlMatch.forEach(element => {
        const text = element[0];
        const hasScheme = Boolean(element[15]);
        const index = element.index;
        urlTmp[index] = { text, hasScheme, type: field_types_1.SegmentType.Url };
    });
    emailMatch.forEach(ele => {
        const text = ele[0];
        const index = ele.index;
        urlTmp[index] = { text, type: field_types_1.SegmentType.Email };
    });
    let seg = '';
    let cur = 0;
    while (cur < str.length) {
        if (cur in urlTmp) {
            if (seg.length) {
                segmentList.push({
                    type: field_types_1.SegmentType.Text,
                    text: seg,
                });
                seg = '';
            }
            const { text, type } = urlTmp[cur];
            segmentList.push({
                type,
                text,
                link: text,
            });
            cur += text.length;
        }
        else {
            seg += str[cur];
            cur++;
        }
    }
    // After the loop is complete, add the text at the end
    if (seg.length) {
        segmentList.push({
            type: field_types_1.SegmentType.Text,
            text: seg,
        });
    }
    return segmentList;
}
exports.string2Segment = string2Segment;
const dateStrReplaceCN = (str) => {
    if (!str) {
        return str;
    }
    return str.replace(/(\s?[年月]\s?)|(\s?[时分]\s?)|([日秒])/g, (_, p1, p2, p3) => {
        if (p1) {
            return '/';
        }
        if (p2) {
            return ':';
        }
        if (p3) {
            return '';
        }
        return _;
    });
};
exports.dateStrReplaceCN = dateStrReplaceCN;
/**
 * Convert ordinary strings to pure numeric strings (only string combinations of "+", "-", numbers, "e" and ".")
 * @param input input string or number
 */
function str2NumericStr(input) {
    if (input == null || input === '') {
        return null;
    }
    const regNumber = /[^0-9\.e+-]/g;
    const regSymbol = /(\+|\-|\.)+/g; // try to keep numbers, compatible with cases like '--', '...'
    let tempStr = (input + '').trim();
    tempStr = tempStr.replace(regNumber, '');
    tempStr = tempStr.replace(regSymbol, '$1');
    const result = parseFloat(tempStr);
    if (!result && result !== 0) {
        return null;
    }
    return result.toString();
}
exports.str2NumericStr = str2NumericStr;
/**
 * Display in currency
 * @param input input number or string
 * @param symbol currency symbol
 * @param digits Separation digits
 * @param splitter separator
 * @param symbolAlign currency symbol position
 */
function str2Currency(input, symbol = '', digits = 3, splitter = ',', symbolAlign = field_types_1.SymbolAlign.default) {
    let tempStr = ('' + input).trim();
    let sign = '';
    if (input == null || tempStr === '') {
        return null;
    }
    if (tempStr.startsWith('-')) {
        sign = '-';
        tempStr = tempStr.substring(1);
    }
    if (tempStr.includes('e')) {
        if (symbolAlign === field_types_1.SymbolAlign.right) {
            return `${sign}${tempStr}${symbol}`;
        }
        return `${sign}${symbol}${tempStr}`;
    }
    if (!tempStr.includes('.')) {
        tempStr += '.';
    }
    const regExp = new RegExp(`(\\d)(?=(\\d{${digits}})+\\.)`, 'g');
    tempStr = tempStr.replace(regExp, function (_$0, $1) {
        return $1 + splitter;
    }).replace(/\.$/, '');
    if (!tempStr) {
        return null;
    }
    if (symbolAlign === field_types_1.SymbolAlign.right) {
        return `${sign}${tempStr}${symbol}`;
    }
    return `${sign}${symbol}${tempStr}`;
}
exports.str2Currency = str2Currency;
function truncateText(text, maxLength = 20, postfix = '...') {
    if (text.length <= maxLength)
        return text;
    return `${text.slice(0, maxLength)}${postfix}`;
}
exports.truncateText = truncateText;
//# sourceMappingURL=string.js.map